
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32","stroke":"#000","fill":"none","stroke-linejoin":"round","stroke-miterlimit":"10"}},[_c('circle',{attrs:{"cx":"16","cy":"16","r":"13"}}),_c('path',{attrs:{"d":"M16 7.307l-.001 10.325"}}),_c('line',{attrs:{"stroke-linecap":"round","transform":"matrix(1.6 0 0 1.6 16 21.8)"}})])
      }
    
      }
    